import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

class ServiceReassignmentWidgetFilter extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null
        };

        this.handleChangeRangePicker = this.handleChangeRangePicker.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
    }

    handleChangeRangePicker = (date) => {
        let startDate = null,
            endDate = null;
        if (date.length) {
            startDate = date[0].format(this.dateFormat);
            endDate = date[1].format(this.dateFormat);
        }
        this.setState({
            startDate,
            endDate
        });
    };

    handleFilter = () => {
        const {
            startDate,
            endDate
        } = this.state;
        this.props.onSubmit(startDate, endDate);
    };

    render() {
        let {
            startDate,
            endDate
        } = this.state;

        startDate = startDate !== null
            ? moment(startDate, this.dateFormat)
            : null;
        endDate = endDate !== null
            ? moment(endDate, this.dateFormat)
            : null;

        return (
            <div className="d-flex justify-content-center align-content-center align-items-center pt-1 pb-1">
                <div className="d-inline-flex mr-2">
                    Filter:
                </div>
                <div className="d-inline-flex text-center mr-2 ml-2">
                    <RangePicker
                        className="g-ant-input-no-padding"
                        value={[
                            startDate,
                            endDate
                        ]}
                        format={this.dateFormat}
                        onChange={(date) => this.handleChangeRangePicker(date)}
                    />
                </div>
                <div className="d-inline-flex text-right">
                    <button
                        className="btn btn-primary"
                        onClick={this.handleFilter}
                    >
                        Submit
                    </button>
                </div>
            </div>
        );
    }
}

ServiceReassignmentWidgetFilter.propTypes = {
    onSubmit: PropTypes.func
};

export default ServiceReassignmentWidgetFilter;
